<!-- @format -->

@if (starsIcon()) {
	@for (star of starsIcon(); track trackByStar($index, star)) {
		<homefield-icon
			[name]="star"
			width="{{ options().width }}"
			height="{{ options().height }}"></homefield-icon>
	}
}
